import React from "react";
import { TextField, InputAdornment } from "@mui/material";

interface TextInputFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  type?: string;
  icon?: React.ReactNode;
  error?: boolean;
  helperText?: string;
  maxLength?: number;
}

const TextInputField: React.FC<TextInputFieldProps> = ({
  label,
  name,
  value,
  onChange,
  required = false,
  type = "text",
  icon,
  error = false,
  helperText = "",
  maxLength,
}) => {
  return (
    <TextField
      fullWidth
      required={required}
      type={type}
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      inputProps={{ maxLength }}
      InputProps={{
        startAdornment: icon ? (
          <InputAdornment position="start">{icon}</InputAdornment>
        ) : undefined,
      }}
    />
  );
};

export default TextInputField;
